module.exports = __webpack_public_path__ + "img/clothing203.cedd31be.jpg";